export default __webpack_public_path__ + "static/media/ClearanceFitsImg.e66105df.jpg";